import React from 'react';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Calendar } from 'lucide-react';

export const DateField = Node.create({
  name: 'dateField',

  group: 'inline',
  inline: true,
  atom: false,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      id: { default: null },
      value: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'date-field' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        class:
          'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-amber-200 bg-amber-50 text-sm font-medium text-amber-800',
      },
      HTMLAttributes.value || 'Date',
    ];
  },

  addCommands() {
    return {
      insertDate:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              id: crypto.randomUUID(),
              value: '',
            },
          });
        },
    };
  },
});

function DateView({ node, getPos }) {
  const onDragStart = (e) => {
    try {
      const from = typeof getPos === 'function' ? getPos() : null;
      const payload = JSON.stringify({
        type: 'editor-drag',
        nodeType: 'dateField',
        from,
        id: node.attrs.id,
      });
      e.dataTransfer.setData('application/x-rp-editor', payload);
      e.dataTransfer.setData('text/plain', payload);
      e.dataTransfer.effectAllowed = 'move';
      console.debug('[NodeView] date dragstart', payload);
    } catch (err) {
      console.log('error', err);
    }
  };

  const display = node.attrs.value || 'Select date';

  return (
    <NodeViewWrapper
      as="span"
      draggable
      onDragStart={onDragStart}
      data-rp-node="date"
      className="
        inline-flex items-center gap-2 align-middle my-0.5
        rounded-lg border border-amber-200/80
        bg-gradient-to-r from-amber-50 to-yellow-50/50
        px-3 py-1.5 text-sm font-medium text-amber-800
        shadow-sm transition-all cursor-grab
        hover:border-amber-300 hover:shadow-md
      "
    >
      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-amber-100 text-amber-700 ring-1 ring-amber-200">
        <Calendar className="h-3 w-3" strokeWidth={2.25} />
      </span>
      <span>{display}</span>
    </NodeViewWrapper>
  );
}

DateField.addNodeView = function () {
  return ReactNodeViewRenderer(DateView);
};
